import React from "react";
import convert from "convert-units";
import round from "lodash/round";
import map from "lodash/map";
import range from "lodash/range";

const {
  PARAMETER_OPTIONS: {
    SETS,
    ROUNDS,
    REPS,
    RPE,
    RPEAMRAP,
    TIME,
    DISTANCE,
    LOAD,
    REST,
    VELOCITY,
    FREEFORM,
  },
} = require("../../constants");

import convertToRiR from "../../utils/converters/convert-intensity";

class TextAreaComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      class: "row1",
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    let defaultValue = this.props.defaultValue ? this.props.defaultValue : 0;
    const classRow1 = { class: "row1" };
    const classRow2 = { class: "row2" };
    this.setState(defaultValue.length > 33 ? classRow2 : classRow1);
  }

  handleChange(e) {
    const classRow1 = { class: "row1" };
    const classRow2 = { class: "row2" };
    this.setState(e.target.value.length > 33 ? classRow2 : classRow1);
  }

  render() {
    const { id, className, name, onInput, defaultValue, key } = this.props;
    return (
      <textarea
        className={`${className} ${this.state.class}`}
        name={name}
        onInput={onInput}
        defaultValue={defaultValue}
        id={id}
        key={key}
        maxLength="45"
        onChange={(e) => this.handleChange(e)}
      />
    );
  }
}

class ParameterInput extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
  }

  /**
   * Function to be sure we are not using wrong values in load input
   * @param {*} e
   */
  handleInputLoad = (e) => {
    let value = e.target.value;

    //replace , for .
    value = value.replace(",", ".");

    //Allow only numbers and .
    value = value.replace(/[^0-9.]/g, "");

    //being sure only exists 1 .
    const parts = value.split(".");
    if (parts.length > 2) {
      value = parts[0] + "." + parts.slice(1).join("");
    }

    e.target.value = value;

    if (this.props.onInput) {
      this.props.onInput(e);
    }
  };

  render() {
    const {
      id,
      name,
      defaultValue,
      onInput,
      parameter,
      onChange,
      keyParam,
      units,
      intensityMeasure,
      isRiR,
      className = "",
      loadDrop,
    } = this.props;

    if (parameter === FREEFORM) {
      return (
        <TextAreaComp
          className={className}
          name={name}
          onInput={onInput}
          defaultValue={defaultValue}
          id={id}
          key={keyParam}
        />
      );
    } else if ([TIME, REST, DISTANCE, VELOCITY, REPS].includes(parameter)) {
      return (
        <input
          className={className}
          type="text"
          name={name}
          onInput={onInput}
          defaultValue={defaultValue}
          id={id}
          maxLength="6"
          key={keyParam}
        />
      );
    } else if (parameter === LOAD && loadDrop) {
      return (
        <div className={className}>
          <input
            className={`${className} !text-left`}
            type="text"
            name="loadDrop"
            onInput={onInput}
            defaultValue={loadDrop}
          />
          <span
            className="quick-edit-load-unit"
            style={{
              marginLeft: "-16px",
            }}
          >
            % mod.
          </span>
        </div>
      );
    } else if (parameter === LOAD) {
      return (
        <div className={className}>
          <input
            className={className}
            type="text"
            name={name}
            onInput={this.handleInputLoad}
            defaultValue={
              units === "metric"
                ? defaultValue ?? 0
                : round(
                    convert(defaultValue ?? 0)
                      .from("kg")
                      .to("lb")
                  )
            }
            id={id}
            key={keyParam}
          />
          <span
            className="quick-edit-load-unit"
            style={{
              marginLeft: "-16px",
            }}
          >
            {defaultValue ? (units === "metric" ? "kg" : "lb") : null}
          </span>
        </div>
      );
    } else if ([RPE, RPEAMRAP].includes(parameter)) {
      return (
        <select
          id={id}
          key={keyParam}
          className={className}
          name="rpe"
          defaultValue={defaultValue}
          onChange={onChange}
        >
          <option value="">{intensityMeasure}</option>

          {map(range(4, 9.5, 0.5), (i) => (
            <option key={i} value={i + 1}>
              {convertToRiR(i + 1, !isRiR)}
            </option>
          ))}
          <option value="AMRAP">AMRAP</option>
        </select>
      );
    }

    return (
      <input
        className={className}
        type="number"
        min={1}
        step="1"
        name={name}
        onInput={onInput}
        defaultValue={defaultValue}
        id={id}
        key={keyParam}
      />
    );
  }
}

export default ParameterInput;
